import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks';

/**
 * Top navigation bar — displays app name and sign-out action.
 * Stays fixed at the top with a glass background so content scrolls beneath it.
 */
function NavBar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-brand-950/80 backdrop-blur-md border-b border-white/10"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="max-w-lg mx-auto px-4 h-14 flex items-center justify-between">
        {/* Logo + name */}
        <div className="flex items-center gap-2">
          <span className="text-xl" role="img" aria-label="paw">🐾</span>
          <span className="font-display font-bold text-white text-lg">PetNoter</span>
        </div>

        {/* User pill + sign-out */}
        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-xs text-white/40 truncate max-w-[140px]">
            {user?.email}
          </span>
          <button
            id="nav-sign-out"
            onClick={() => void handleSignOut()}
            className="text-xs font-medium text-white/60 hover:text-white bg-white/10 hover:bg-white/20 border border-white/10 px-3 py-1.5 rounded-xl transition-all duration-200"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}

export default NavBar;
